<template>
    <div class="d-inline-block">
        <b-overlay :show="isDataSending" rounded opacity="0.6" spinner-small spinner-variant="primary">
            <b-btn :disabled="!$store.getters.getCanSign || !isAvailable" @click="showSignForm" variant="custom-green">Подписать и отправить контракт</b-btn>
        </b-overlay>
        <template v-if="!$store.getters.getCanSign">
            <span v-if="$store.getters.getLoginType === 'cert'" class="text-danger pl-3 pt-0 fs-14 w-50 my-auto">Для действия требуется загрузить/заменить МЧД на странице: <router-link :to="{ name: 'CabinetUserProfile' }" class="green-link">Данные учетной записи</router-link></span>
            <span v-else class="text-danger pl-3 pt-0 fs-14 w-50 my-auto">Подписание возможно только при авторизации при помощи ЭЦП</span>
        </template>
        <b-modal ref="sign-form-modal" v-model="showSignModal" centered no-close-on-backdrop no-close-on-esc scrollable size="lg" title="Подписать и отправить контракт" @close="cancelSignModal">
            <template #modal-header-close>
                <button-close-modal />
            </template>
            <div class="d-block text-left">
                <b-tabs content-class="mt-3 px-3">
                    <b-tab active>
                        <template #title>
                            <span class="system_link-style fs-16">Данные закупки</span>
                        </template>
                        <h4 class="font-weight-bold">Информация о заказчике</h4>
                        <text-row compact label="Наименование организации" :value="purchase.contract.customer.name" />
                        <text-row compact label="ИНН" :value="purchase.contract.customer.inn" />
                        <text-row compact label="КПП" :value="purchase.contract.customer.kpp" />
                        <text-row compact label="ОГРН" :value="purchase.contract.customer.ogrn" />
                        <text-row compact label="Адрес" :value="purchase.contract.customer.legal_address" />

                        <h4 class="font-weight-bold">Информация о поставщиике</h4>
                        <text-row compact label="Наименование организации" :value="purchase.contract.supplier.name" />
                        <text-row compact label="ИНН" :value="purchase.contract.supplier.inn" />
                        <text-row compact label="КПП" :value="purchase.contract.supplier.kpp" />
                        <text-row compact label="ОГРН" :value="purchase.contract.supplier.ogrn" />
                        <text-row compact label="Адрес" :value="purchase.contract.supplier.legal_address" />

                        <hr />
                        <h4 class="font-weight-bold">Условия закупки</h4>
                        <text-row compact :label-cols-lg="4" :label-cols-sm="4" label="Объект закупки" :value="purchase.purchase_terms.purchase_object" />
                        <text-row compact :label-cols-lg="4" :label-cols-sm="4" label="Предмет закупки" :value="purchase.purchase_terms.deliverable_group.name" />
                        <text-row compact :label-cols-lg="4" :label-cols-sm="4" label="Тип закупки" :value="purchase.purchase_terms.order_type.name" />
                        <text-row-price compact :label-cols-lg="4" :label-cols-sm="4" label="Цена контракта" :value="purchase.purchase_terms.contract_price" />
                        <text-row compact :label-cols-lg="4" :label-cols-sm="4" label="Продолжительность закупочной сессии" :value="purchase.purchase_terms.duration_type.name" />
                        <text-row-boolean-text compact :label-cols-lg="4" :label-cols-sm="4" label="Аванс" :value="purchase.purchase_terms.with_advance" />
                        <text-row v-if="purchase.purchase_terms.with_advance" compact :label-cols-lg="4" :label-cols-sm="4" label="Размер аванса" :value="purchase.purchase_terms.advance_percentage + '%'" />
                        <text-row-date compact :label-cols-lg="4" :label-cols-sm="4" label="Планируемая дата заключения договора" :value="purchase.purchase_terms.planned_contract_conclusion_date" />
                        <text-row-date compact :label-cols-lg="4" :label-cols-sm="4" label="Планируемая дата исполнения договора" :value="purchase.purchase_terms.planned_contract_execution_date" />
                        <text-row-single-document compact :label-cols-lg="4" :label-cols-sm="4" label="Проект ГК" :value="purchase.purchase_terms.contract_draft_attachment" />
                        <text-row-single-document v-if="purchase.purchase_terms.commercial_proposal_form_attachment" compact :label-cols-lg="4" :label-cols-sm="4" label="Образец коммерческого предложения для заполнения" :value="purchase.purchase_terms.commercial_proposal_form_attachment" />
                        <text-row
                            compact
                            :label-cols-lg="4"
                            :label-cols-sm="4"
                            label="Информация о возможности и случаях одностороннего расторжения сделки в соответствии с действующим законодательством Российской Федерации"
                            :value="purchase.purchase_terms.unilateral_contract_termination_info"
                            text-wrap />

                        <template v-if="purchase.delivery_terms.addresses.length > 0 || purchase.delivery_terms.schedule">
                            <hr />
                            <h4 class="font-weight-bold">Условия поставки</h4>
                            <b-form-group v-if="purchase.delivery_terms.addresses.length > 0" :label-cols-sm="4" :label-cols-lg="4" label="Адреса для доставки/самовывоза:" label-class="fs-14 grey-color fw-700 d-flex align-items-baseline" class="mb-0">
                                <ul>
                                    <li v-for="(address, index) in purchase.delivery_terms.addresses" :key="index" class="fs-14 grey-color my-auto col-form-label pb-0">{{ index + 1 + '. ' + address.address ?? address }}</li>
                                </ul>
                            </b-form-group>
                            <text-row compact :label-cols-lg="4" :label-cols-sm="4" label="График поставки товаров (выполнения работ, оказания услуг)" :value="purchase.delivery_terms.schedule" text-wrap />
                        </template>

                        <hr />
                        <h4 class="font-weight-bold">Спецификация</h4>
                        <b-form-group v-if="purchase.supplier_proposal.deliverables.length > 0">
                            <ul>
                                <li v-for="(item, index) in purchase.supplier_proposal.deliverables" :key="index" class="fs-14 grey-color my-auto col-form-label py-1">{{ index + 1 + '.' }} {{ item.ktru_item.name }} - {{ item.ktru_item.okei_local_symbol }}: Цена за ед. {{ item.price }} руб.{{ purchase.supplier_proposal.without_vat ? '' : `, ${item.vat.title}` }}</li>
                            </ul>
                        </b-form-group>

                        <template v-if="purchase.additional_documents.length > 0">
                            <hr />
                            <h4 class="font-weight-bold">Дополнительные документы</h4>
                            <text-row-documents label="Дополнительные документы" v-model="purchase.additional_documents" compact />
                        </template>

                        <hr />
                        <h4 class="font-weight-bold">Требования к участникам закупки</h4>
                        <template v-if="purchase.supplier_requirements.supplier_reqs_a">
                            <text-row-boolean-text
                                :label-cols-sm="11"
                                :label-cols-lg="11"
                                value-class="text-right"
                                v-model="purchase.contract.supplier_requirements.supplier_reqs_a"
                                label="Поставщик подтвердил, что соответствует требованиям п.1 ч.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ"
                                compact />
                            <div style="word-break: break-all" class="form-row">
                                <div class="col">
                                    <p class="fs-14 grey-color my-1"><strong>Поставщик подтвердил, что соответствует следующим требованиям</strong> - {{ purchase.supplier_requirements.supplier_reqs_a_details.supplier_reqs_a_text }}</p>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="col">
                                    <p class="fs-14 grey-color mt-2 mb-1"><strong>Поставщик подтвердил, что соответствует указанным требованиям, приложив следующие документы:</strong></p>
                                </div>
                            </div>
                            <text-row-single-document
                                v-for="(item, index) in purchase.supplier_requirements.supplier_reqs_a_details.supplier_reqs_a_documents"
                                :key="`supplier_required_document_${index}`"
                                :label="item.name"
                                v-model="purchase.contract.supplier_requirements.supplier_required_documents[index].storedDocument"
                                :label-cols-lg="4"
                                compact />
                        </template>
                        <text-row-boolean-text
                            v-if="purchase.supplier_requirements.supplier_reqs_b"
                            :label-cols-sm="11"
                            :label-cols-lg="11"
                            value-class="text-right"
                            v-model="purchase.contract.supplier_requirements.supplier_reqs_b"
                            label="Поставщик подтвердил, что соответствует требованиям п.3-5, 7-11 ч.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ"
                            compact />
                        <text-row-boolean-text
                            v-if="purchase.supplier_requirements.supplier_reqs_c"
                            :label-cols-sm="11"
                            :label-cols-lg="11"
                            value-class="text-right"
                            v-model="purchase.contract.supplier_requirements.supplier_reqs_c"
                            label="Поставщик подтвердил, что соответствует требованиям ч.1.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ"
                            compact />
                        <text-row-boolean-text
                            v-if="purchase.supplier_requirements.supplier_reqs_sonko"
                            :label-cols-sm="11"
                            :label-cols-lg="11"
                            value-class="text-right"
                            v-model="purchase.contract.supplier_requirements.supplier_reqs_sonko"
                            label="Поставщик подтвердил, организация является социально ориентированной некоммерческой организацией (СОНКО)"
                            compact />
                        <template v-if="purchase.supplier_requirements.has_additional_requirements">
                            <div class="form-row">
                                <div class="col">
                                    <p class="fs-14 grey-color my-2 mb-1">
                                        <strong>Поставщик подтвердил соответствие дополнительным требованиям, приложив следующие документы:</strong>
                                    </p>
                                </div>
                            </div>
                            <text-row-single-document
                                v-for="(item, index) in purchase.supplier_requirements.additional_requirements"
                                :key="`additional_requirement_${index}`"
                                v-model="purchase.contract.supplier_requirements.additional_requirements[index].attachment"
                                :label-cols-lg="4"
                                :label="`${index + 1}. ${item.description} (причина: ${item.reason})`"
                                compact />
                        </template>
                    </b-tab>
                    <b-tab>
                        <template #title>
                            <span class="system_link-style fs-16">XML</span>
                        </template>
                        <b-form-textarea v-if="!isSignedXml" v-model="formXml" disabled rows="20" no-resize no-auto-shrink wrap="off" class="text-monospace fs-12"></b-form-textarea>
                        <b-form-textarea v-else v-model="signedFormXml" disabled rows="20" no-resize no-auto-shrink wrap="off" class="text-monospace fs-12"></b-form-textarea>
                    </b-tab>
                </b-tabs>
            </div>
            <div slot="modal-footer" class="w-100 px-3">
                <text-row compact label="Сертификат" :value="certificate?.subjectName" />
                <b-button :disabled="isDataSending" class="mr-2 text-uppercase" variant="custom-outline-secondary" @click="cancelSignModal">Отмена</b-button>
                <b-overlay v-if="!isSignedXml" :show="isSigningXml" class="d-inline-block" opacity="0.6" rounded spinner-small spinner-variant="primary">
                    <b-button :disabled="!certificate" class="text-uppercase" variant="custom-green" @click="signForm">Подписать</b-button>
                </b-overlay>
                <b-overlay v-else :show="isDataSending" class="d-inline-block" opacity="0.6" rounded spinner-small spinner-variant="primary">
                    <b-button :disabled="!certificate" class="text-uppercase" variant="custom-green" @click="sendData">Отправить</b-button>
                </b-overlay>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { createMultipleSignatures, getCertificate } from 'crypto-pro';

export default {
    name: 'fl44-unknown-volume-customer-sign-contract-button',
    props: {
        purchase: {
            type: Object,
            required: true
        },
        isAvailable: {
            type: Boolean,
            default: false
        },
        form: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            showSignModal: false,
            isSigningXml: false,
            formXml: '',
            signedFormXml: null,
            signedAttachments: [],
            isSignedXml: false,
            isDataSending: false,
            certificate: null
        }
    },
    methods: {
        async signForm() {
            this.isSigningXml = true;
            const dataToSign = [
                {
                    method: 'xml',
                    value: this.formXml
                },
                {
                    method: 'detached',
                    value: this.purchase.contract.contract_file.contract_attachment.hash,
                    id: this.purchase.contract.contract_file.contract_attachment.id
                }
            ];
            const attachmentsCount = dataToSign.filter((item) => item.method === 'detached').length;
            const signedResult = await createMultipleSignatures(this.$store.getters.getCurrentThumbprint, dataToSign, true);
            this.signedFormXml = signedResult.find((item) => item.method === 'xml').result;
            this.signedAttachments.splice(0);
            if (attachmentsCount > 0) {
                dataToSign.filter((item) => item.method === 'detached').forEach((item) => {
                    const result = signedResult.find((resultItem) => resultItem.method === 'detached' && resultItem.value === item.value);
                    this.signedAttachments.push({
                        id: item.id,
                        hash: item.value,
                        md5: result.result
                    });
                })
            }
            this.isSignedXml = !!this.signedFormXml && this.signedAttachments.length === attachmentsCount && this.signedAttachments.every((item) => item.md5 !== null);
            this.isSigningXml = false;
        },
        async sendData() {
            this.isDataSending = true;
            this.certificate = await getCertificate(this.$store.getters.getCurrentThumbprint);
            if (!this.certificate) {
                return;
            }
            const data = {
                ...this.form,
                xml: this.signedFormXml,
                certificate: this.certificate,
                signed_attachments: this.signedAttachments
            };
            await this.$api.products.fl44UnknownVolume.contracts
                .storeSigned(this.purchase.id, this.purchase.contract.id, 'customer', data)
                .then((response) => {
                    if (response) {
                        this.cancelSignModal();
                        this.$emit('refresh');
                    }
                })
                .finally(() => {
                    this.isDataSending = false;
                });

        },
        async showSignForm() {
            if (!this.$store.getters.getCanSign) {
                return;
            }
            this.certificate = await getCertificate(this.$store.getters.getCurrentThumbprint);
            if (!this.certificate) {
                return;
            }
            this.$api.products.fl44UnknownVolume.contracts.getXml(this.purchase.id, this.purchase.contract.id).then((resp) => {
                this.formXml = resp.xml;
                this.showSignModal = true;
            });
        },
        cancelSignModal() {
            this.isSignedXml = false;
            this.showSignModal = false;
            this.isSigningXml = false;
        }
    }
};
</script>
